export const environment = {
    production: false,
    defaultauth: 'fake-backend',
    firebaseConfig: {
        apiKey: '',
        authDomain: '',
        databaseURL: '',
        projectId: '',
        storageBucket: '',
        messagingSenderId: '',
        appId: '',
        measurementId: ''
    },
    api_url_mail: '',
    // ทุกอย่างเรียกผ่าน nginx ของเว็บ (same-origin) จึงใช้ได้ทุกเครื่อง ไม่ต้องแก้ IP:
    //   /api      -> backend      (BACKEND_URL ใน docker-compose)
    //   /car-api  -> เครื่องนับรถ (CAR_COUNTER_URL ใน docker-compose) ทั้งวิดีโอและตัวเลข
    car_video_url: '/car-api',
    car_count_url: '/car-api',
    api_nestjs: '/api',
    web_url: window.location.origin
    // api_nestjs: 'https://foodvilla-ems.com:3004/api',
    // web_url: 'https://foodvilla-ems.com'
};